import { useApiClient } from '@chilipiper/api-client/src/context'
import {
  GetPublicLocalizationEntriesResponse,
  PublicLocalizationEntry,
} from '@chilipiper/api-client/src/customization-settings'
import { captureException } from '@chilipiper/sentry'
import { useQuery } from '@tanstack/react-query'

const APPLIED_TRANSLATIONS_QUERY_KEY = ['customization-settings', 'translations']

const useGetExternalLocalizationEntries = (tenantId: string, workspaceId: string) => {
  const { customizationSettings } = useApiClient()
  const defaultResponse: GetPublicLocalizationEntriesResponse = {
    list: [],
    allowedLanguages: ['en-US'],
  }
  return useQuery({
    queryKey: [APPLIED_TRANSLATIONS_QUERY_KEY, tenantId, workspaceId],
    queryFn: () => {
      return customizationSettings
        .guestExternalListAppliedLocalizationEntries(tenantId, workspaceId)
        .catch(error => {
          captureException(error)
          return defaultResponse
        })
    },
    enabled: !!tenantId && !!workspaceId,
  })
}

export const useTranslationsWithEnglishFallback = (
  tenantId: string,
  workspaceId: string,
  locale: string
): PublicLocalizationEntry[] => {
  const { data: translationsResponse } = useGetExternalLocalizationEntries(tenantId, workspaceId)

  const getTranslationsForLocale = (localeCode: string): PublicLocalizationEntry[] =>
    translationsResponse?.list?.filter(translation => translation.locale === localeCode) ?? []

  const currentLocaleTranslations = getTranslationsForLocale(locale)
  const englishTranslations = getTranslationsForLocale('en-US')

  return currentLocaleTranslations.length > 0 ? currentLocaleTranslations : englishTranslations
}
